import { useState } from 'react';
import { X } from 'lucide-react';

const VisitorCheckoutAlert = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="relative mb-2">
      <div className="bg-orange-100 text-xs p-4 rounded text-blue-800 relative ">
        {/* Close Button - Positioned Top Right */}
        <button
          onClick={() => setIsVisible(false)}
          className="absolute top-1 right-1 text-blue-800 hover:text-blue-600"
        >
          <X size={16} />
        </button>
        <ul className="text-sm leading-relaxed space-y-2">
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            Tenderwise ইতিপূর্বে রেজিস্ট্রেশন না থাকলে, এই ইমেইল/ফোন নম্বরেই
            স্বয়ংক্রিয়ভাবে রেজিস্ট্রেশন হবে।
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            ফোন নম্বর অবশ্যই কান্ট্রি কোডসহ দিতে হবে, এটিতেই OTP ও লগইন
            ক্রিডেনশিয়াল যাবে।
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            ইতিপূর্বে রেজিস্ট্রেশন করা থাকলে, সেই ইমেইল/ফোন নম্বর এখানে দিলে
            আগের প্যাকেজের সাথে নতুনটি যোগ হবে।
          </li>
          <li className="flex items-start gap-2">
            <span className="text-blue-600">●</span>
            নতুন প্যাকেজ কিনে প্রিমিয়াম ইউজার হলে, এখানে দেওয়া ইমেইলেই দৈনিক
            টেন্ডার আপডেট পাবেন।
          </li>
        </ul>
      </div>
    </div>
  );
};

export default VisitorCheckoutAlert;
